import { CARD_FIELD_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import FieldContent from "../../useful/FieldContent"
import {
    CardFieldEmpty
} from "../cardField"
import { ICardFieldProps } from "./CardField"


/* Protopia Ecosystem component */ 
const CardFieldContent = (props: ICardFieldProps): JSX.Element => {
    if(typeof props.value === "undefined") { 
        return <CardFieldEmpty {...props} />
    }
    const isCanvasEnable = ( fieldType: string ): boolean => {
        if(fieldType === CARD_FIELD_TYPE.CANVAS) {
            return false
        }
        const canvases: any[] = props.contentData?.card_fields.filter(key => {
            return key.type === CARD_FIELD_TYPE.CANVAS
        }) || []
        
        let isEnabled = false
        canvases.forEach((key: any, i: number) => {
            
            isEnabled = isEnabled || !! key[fieldType]
        } ) 
        return isEnabled
    } 
    
    if(isCanvasEnable( props.field.pseudonym || "" ) || CARD_FIELD_TYPE.BACKGROUND === props.field.type ) return <></>    
    // console.log("content:", props.field.pseudonym,  props  )    
    return <FieldContent {...props} />
}
export default CardFieldContent


